import React from 'react';
import styled from 'styled-components';
import { tokens } from '../../design/tokens';
import Footer from './Footer';

const Main = styled.main<{ $isAdmin?: boolean }>`
  flex: 1;
  display: block;
  width: 100%;
  margin: 0;
  padding: ${props => props.$isAdmin ? '0' : tokens.spacing.xl};
`;

export const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const isAdmin = typeof window !== 'undefined' && window.location.pathname.startsWith('/admin');

  return (
    <>
      <a href="#main" className="skip-link">Pular para o conteúdo</a>
      <Main $isAdmin={isAdmin} id="main" role="main">
        {children}
      </Main>
      <Footer />
    </>
  );
};

export default Layout;